import classNames from 'classnames';

import styles from '../../../styles/icons/base.module.scss';

interface ArrowIconProps {
    direction?: 'left' | 'right';
    color?: string;
    className?: string;
}

function TinderArrowIcon({
    direction = 'right',
    color = 'currentColor',
    className = null,
}: ArrowIconProps) {
    return (
        <svg
            className={classNames([styles.container, { [className]: className !== null }])}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width={22.31}
            height={9.69}
            viewBox="0 0 22.31 9.69"
        >
            <g
                style={{
                    transform: direction === 'left' ? 'scaleX(-1)' : null,
                    transformOrigin: 'center',
                    transition: '0.3s transform ease',
                }}
            >
                <path
                    fill={color}
                    d="M18.29,7.46c-0.77-0.5-1.53-1.02-2.31-1.5c-2.99-1.89-6.34-3.13-9.85-3.65
	C4.52,2.09,2.89,2.07,1.28,2.25C0.79,2.34,0.3,2.09,0.1,1.64C-0.11,1.22,0,0.71,0.36,0.42c0.24-0.16,0.51-0.27,0.8-0.3
	c1.77-0.19,3.56-0.16,5.32,0.09c4.77,0.76,9.27,2.68,13.11,5.59l0.56,0.4c0.02-0.19,0.03-0.31,0.03-0.43c0-1.13,0-2.27,0-3.4
	c-0.06-0.59,0.36-1.11,0.95-1.17c0.59-0.06,1.11,0.36,1.17,0.95c0.01,0.08,0.01,0.16,0,0.23c0,2.04,0,4.09,0,6.13
	c0.07,0.58-0.35,1.11-0.93,1.18c-0.08,0.01-0.16,0.01-0.24,0c-2.06,0.01-4.12,0.01-6.17,0c-0.58,0.05-1.1-0.38-1.15-0.97
	c-0.05-0.58,0.38-1.1,0.97-1.15c0.06-0.01,0.12-0.01,0.18,0c1.09-0.01,2.18,0,3.27,0L18.29,7.46"
                />
            </g>
        </svg>
    );
}

export default TinderArrowIcon;
